// 假进度条
type ProgressUpdatedCallback = (progress: number) => void;

const defaultTotal = 20;

export function useProgress() {
  let timer: NodeJS.Timeout | undefined;
  let progress: number;
  let progressUpdatedCallback: ProgressUpdatedCallback | undefined;
  let started = false;

  const close = () => {
    timer && clearInterval(timer);
    progress = 0;
    progressUpdatedCallback = undefined;
    timer = undefined;
    started = false;
  };

  const start = (total = defaultTotal) => {
    if (started) {
      return;
    }

    started = true;
    let step = 100 / (typeof total === 'number' ? total : defaultTotal);
    step = Number(step.toFixed(1))
    progress = 1;

    typeof progressUpdatedCallback === 'function' && progressUpdatedCallback(progress);

    timer = setInterval(() => {
      if (progress + step < 100) {
        progress += step;

        typeof progressUpdatedCallback === 'function' && progressUpdatedCallback(progress);
      } else {
        progress = 99;

        typeof progressUpdatedCallback === 'function' && progressUpdatedCallback(progress);
        close();
      }
    }, 1000);
  };

  const onProgressUpdated = (callback: ProgressUpdatedCallback) => {
    progressUpdatedCallback = callback;
  };


  return {
    start,
    onProgressUpdated,
    close
  }
}